import React from 'react';
import { useMsal } from '@azure/msal-react';
import BookingSummary from 'Components/BookingSummary/BookingSummary';
import Button from 'Components/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { SummaryWrapper } from 'Components/Calendar/CalendarComponents';
import { BookingAPI } from 'API/BookingAPI';

type SummaryContainerProps = {
    selectedDates: string[];
    hideContinueBtn: boolean;
    totalCost: number;
}

function SummaryContainer({ selectedDates, hideContinueBtn, totalCost }: SummaryContainerProps) {
    const { mhid, mhname } = useParams<{ mhid: string, mhname: string }>();
    const navigate = useNavigate();
    const { instance } = useMsal();
    
    const addInitialBooking = async () => {
        const response = await BookingAPI.add(instance, selectedDates[0], selectedDates[selectedDates.length -1], parseInt(mhid ?? ""));
        navigate(`/BookingDetails/${response.returnValue}/${mhname}`);
    }
    
    return (
        <SummaryWrapper>
            <BookingSummary selectedDates={selectedDates} totalCost={totalCost}/>
            <div style={{display:"flex", justifyContent: "center"}}>
                {selectedDates.length > 1 && !hideContinueBtn && 
                    <Button type={"button"} colour={"dark"} width={"90%"} text={"continue booking"} onClick={() => addInitialBooking()} css={{ marginTop: "1em" }}/>
                }
            </div>
        </SummaryWrapper>
                
    );
}
export default SummaryContainer;